import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PhxBaseDetailSaveButtonComponent } from "../../../../shared/components/phx-base-detail-save-button/phx-base-detail-save-button.component";
import { BlockableDiv } from "../../../../shared/controls/blockable-div/blockable-div.component";
import { WidgetSetMenuToUserComponent } from "./widget-set-menu-to-user.component";

@Component({
  selector: 'app-formly-set-menu-to-user',
  imports: [
    BlockableDiv,
    WidgetSetMenuToUserComponent,
    PhxBaseDetailSaveButtonComponent,
    TranslatePipe
  ],
  template: `
    <blockable-div [blocked]="!model?.id" [blockUi]="blockUi">
      @defer (when model?.id) {
          <app-widget-set-menu-to-user
            [selectedUser]="model"
            [showUserDropdown]="false"
          />
        }
    </blockable-div>

    <ng-template #blockUi>
        <app-phx-base-detail-save-button
          [baseDetailComponent]="formState.detailComponent"
          [saveButtonLabel]="'common.save' | translate"
        />
    </ng-template>
  `,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlySetMenuToUserComponent extends FieldType<FieldTypeConfig> { }
